// Variables to keep track of the current page and if the page is loading
let page = 1;
let isLoading = false;
let randomPostIds = [];
let selectedPosts = [];
let hasPages = true;

function setParameters(term) {
    // Get the current URL
    let currentUrl = window.location.href;

    // Remove the old attributes from the URL
    currentUrl = currentUrl.replace(/(\?|&)term=[^&]+/gi, '');

    // Construct the updated URL with new attributes
    const separator = currentUrl.indexOf('?') !== -1 ? '&' : '?';
    const updatedUrl = currentUrl + separator + 'term=' + term;

    // Update the URL
    window.history.pushState(null, null, updatedUrl);
}

// Get the URL parameters
const getUrlParameter = (sParam) =>  {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Check if the term parameter is set
var term = getUrlParameter('term');

/**
 *  Load post handler
 *
 * @param {string} term The term to filter on
 * @param {int} page The page number
 */
function loadPosts(term, page = 1) {
    if( page < 2 ) {
        $('.filter-empty').hide();
        $('.filter-results').hide().html('');
    }
    $('.filter-spinner').show();

    let taxonomy = $('input[name="filter-taxonomy"]').val() ? $('input[name="filter-taxonomy"]').val() : false;
    let post_type = $('input[name="filter-post_type"]').val();
    let makelaar = $('input[name="filter-makelaar"]').val();
    let allowed_categories = $('input[name="filter-allowed_categories"]').length ? $('input[name="filter-allowed_categories"]').val() : false;


    // let displayedPost = selectedPosts ? pickPost() : undefined;
    let displayedPost

    if(selectedPosts) {
        displayedPost = pickPost();
    }
    const formattedSelectedPosts = JSON.stringify(selectedPosts);

    $.ajax({
        type: 'POST',
        url: myGlobalData.ajaxurl, // eslint-disable-line
        data: {
            action: 'filter_posts',
            post_type,
            taxonomy,
            makelaar,
            term,
            allowed_categories,
            page,
            exclude_post: formattedSelectedPosts,
            selected_post: displayedPost,
        },
        success: function(response) {
            handleResponse(response);
        },
        error: function(response) {
            console.error('Fout bij laden van posts:', response);
        },
    });
}

/**
 * Handles the AJAX call to get the next post
 * @param {object} response The response from the AJAX call
 */
const handleResponse = (response) => {
    if (page > 1) {
        if(response.success){
            $('.filter-results').append(response.data);
        }
        $('.filter-spinner').hide();
    } else {
        setTimeout(function() {
            if (response.success) {
                $('.filter-results').show().html(response.data);
            } else {
                $('.filter-results').html('');
                $('.filter-empty').show();
            }
            $('.filter-spinner').hide();
        }, 500);
    }
    isLoading = false;

    if(response.success) {
        setTimeout(function() {
            if($('.post-items--archive').length) {
                updateHasMorePages('.post-items__item');
            } else {
                updateHasMorePages('.case-items__item');
            }
        }, 500);
    }
}

/**
 *  Get all the post ids of the interviews to be able to pick a random post from the array. And shuffle the array to a random order.
 *
 * @returns {array} An array of all the post ids
 */
const getAllInterviews = () => {
    return fetch('/wp-json/wp/v2/posts?categories=5')
        .then((response) => response.json())
        .then((data) => {
            return data.map((post) => {
                return post.id;
            });
        })
        .then((data) => {
            return data.sort(() => Math.random() - 0.5)
        });
}


/**
 * Pick a post from the randomPostIds array that is not already shown on the page
 *
 * @returns {int} The post id of the selected post
 */
const pickPost = () => {
    let shownPosts = $('.post-items__item').map(function() {
        return $(this).data('post-id');
    }).get();
    let selectedPost = [];

    for(let i = 0; i < 2; i++) {
        let post = randomPostIds.find(id => !shownPosts.includes(id) && !selectedPost.includes(id));
        if (post) {
            selectedPost.push(post);
            selectedPosts.push(post);
        }
    }

    return JSON.stringify(selectedPost);
}

/**
 * Update the hasMorePages variable based on the amount of posts on the page and the amount of posts in the database for the current term
 * @param {string} type
 */
const updateHasMorePages = (type) => {
    const postsCount = parseInt($(type).attr('data-post-count'), 10);
    const postsPerPage = $('.post-items--archive').length ? 12 : 6;

    hasPages = postsCount > (page * postsPerPage);
}

// Event listeners for loading posts and filter functionality
$(window).on( 'load', function() {
    if($('.post-items--archive').length){
        let urlTerm = getUrlParameter('term');
        term = urlTerm ? urlTerm : 'all';

        getAllInterviews().then((interviews) => {
            randomPostIds = interviews;
            isLoading = true;
            loadPosts(term, 1);

            $(window).scroll(function() {
                if ($('.filter-spinner').is(':visible')) {
                    return;
                }
                
                if(!hasPages) {
                    return;
                }

                if($(window).scrollTop() + $(window).height() >= ($(document).height() - 500)) {
                    let urlTerm = getUrlParameter('term');
                    term = urlTerm ? urlTerm : 'all';
                    if(isLoading)  return;
                    isLoading = true;
                    page ++;

                    loadPosts(term, page);
                }
            });
        });
    }

    if ($('.case-items--archive').length) {
        let urlTerm = getUrlParameter('term');
        term = urlTerm ? urlTerm : 'all';
        isLoading = true;
        loadPosts(term, 1);

        $(window).scroll(function() {
            if ($('.filter-spinner').is(':visible')) {
                return;
            }

            if(!hasPages) {
                return;
            }

            if($(window).scrollTop() + $(window).height() >= ($(document).height() - 500)) {
                let urlTerm = getUrlParameter('term');
                term = urlTerm ? urlTerm : 'all';
                if(isLoading)  return;
                isLoading = true;
                page ++;

                loadPosts(term, page);
            }
        });
    }
});

// Filter posts on click of term item in the filter bar
$(document).on('click', '.filter-posts__term', function() {
    $(this).addClass('active').siblings().removeClass('active');
    var term = $(this).attr('data-term');
    setParameters(term);
    selectedPosts = [];
    page = 1;
    isLoading = true;
    loadPosts(term);
});

// Set the active term
if(term && $('.filter-posts').length) {
    $('.filter-posts__term[data-term="'+term+'"]').addClass('active').siblings().removeClass('active');
}
